import { yotyDesigns } from './yotyDesigns';
export const yotyCatalogue = [
  { name: 'YOTY Shirt', price: 15, items: ['Shirt'] },
  { name: 'YOTY Keychain', price: 5, items: ['Keychain'] },
  { name: 'YOTY Sticker', price: 2.5, items: ['Sticker'] },
  { name: 'YOTY 2 Shirts Bundle', price: 28, items: ['Shirt', 'Shirt'] },
  { name: 'YOTY 5 Shirts Bundle', price: 65, items: ['Shirt', 'Shirt', 'Shirt', 'Shirt', 'Shirt'] },
  { name: 'YOTY 2 Stickers Bundle', price: 4, items: ['Sticker', 'Sticker'] },
  { name: 'YOTY Everything Bundle', price: 20, items: ['Shirt', 'Sticker', 'Keychain'] },
  { name: 'YOTY Shirt + Keychain Bundle', price: 17, items: ['Shirt', 'Keychain'] },
  { name: 'YOTY Shirt + Sticker Bundle', price: 16, items: ['Shirt', 'Sticker'] },
];
export const getYotyProduct = name => yotyCatalogue.find(item => item.name === name);
export const getYotyImages = name => [...new Set((getYotyProduct(name)?.items || [])
  .flatMap(type => yotyDesigns[type].flatMap(design => design.images)))];
export const withYotyImages = product => {
  const images = getYotyImages(product.name);
  return images.length ? { ...product, image: images[0], images } : product;
};
